import React from 'react'
import PropTypes from 'prop-types'
import { scrollToCollapsible } from 'Utils/navigationUtils'
import { _MortgageCTA, _MortgageIcon, _MortgageText, _ArrowIcon } from './styles'

export const MortgageCTA = ({
  text,
  navigationLinks,
  collapsibleIdSuffix,
  pageModalLevel,
  iconSrc,
}) => (
  <_MortgageCTA
    onClick={() => {
      scrollToCollapsible({
        section: navigationLinks.calculator + collapsibleIdSuffix,
        offset: -100,
        containerId: pageModalLevel ? `appModalPage-${pageModalLevel}` : null,
        smooth: true,
        duration: 300,
      })
    }}
  >
    <_MortgageIcon name={iconSrc} alt={'mortgage icon'} height={16} width={16} />
    <_MortgageText>{text}</_MortgageText>
    <_ArrowIcon name="#icon-arrow-final" width={8} height={11} />
  </_MortgageCTA>
)

MortgageCTA.propTypes = {
  text: PropTypes.string,
  navigationLinks: PropTypes.string,
  collapsibleIdSuffix: PropTypes.string,
  pageModalLevel: PropTypes.string,
  iconSrc: PropTypes.string,
}
export default MortgageCTA
